import { addFilter, type FilterCallback } from "@/extensions/hooks";

// When the Suggest modal loads the dependent options for a picked product, pre-selects the
const NAMESPACE = "duke/plugins/apply-default-dependent-option";
const DEFAULT_SKU_TEXTS = ["ctbd", "color to be determined", "to be determined"];

export const applyDefaultDependentOption: FilterCallback<"dependentProducts.preselect"> = (
  value,
  { groups },
) => {
  if (value) return value;

  const defaultGroup = groups.find((group) => {
    const lowerSku = String(group?.skus?.[0] ?? "").toLowerCase();
    return DEFAULT_SKU_TEXTS.some((text) => lowerSku.includes(text));
  });
  return defaultGroup ?? value;
};

export const registerApplyDefaultDependentOption = () =>
  addFilter("dependentProducts.preselect", NAMESPACE, applyDefaultDependentOption);
